(() => {
    const SELECTOR = '[data-sticky-cta-bar]';
    const STATE_KEY = 'stickyCtaBarBootstrap';

    function hasStickyCtaBar(root = document) {
        return Boolean(root.querySelector(SELECTOR));
    }

    function loadScript(src) {
        return new Promise((resolve, reject) => {
            const existing = document.querySelector(`script[src="${src}"]`);
            if (existing) {
                if (existing.dataset.loaded === 'true') return resolve();
                existing.addEventListener('load', () => resolve(), { once: true });
                existing.addEventListener('error', () => reject(new Error(`Failed to load script: ${src}`)), { once: true });
                return;
            }

            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.dataset.loaded = 'false';
            script.addEventListener('load', () => {
                script.dataset.loaded = 'true';
                resolve();
            }, { once: true });
            script.addEventListener('error', () => reject(new Error(`Failed to load script: ${src}`)), { once: true });
            document.head.appendChild(script);
        });
    }

    function ensureLoaded() {
        const src = window.__STICKY_CTA_BAR_SRC;
        if (!src) throw new Error('Missing window.__STICKY_CTA_BAR_SRC');

        const state = window[STATE_KEY] || (window[STATE_KEY] = {});
        if (state.loadingPromise) return state.loadingPromise;

        state.loadingPromise = loadScript(src);
        return state.loadingPromise;
    }

    function initIfNeeded(root = document) {
        if (!hasStickyCtaBar(root)) return;
        ensureLoaded().catch((err) => console.error('[Sticky CTA] init failed:', err));
    }

    document.addEventListener('DOMContentLoaded', () => initIfNeeded(document));

    document.addEventListener('shopify:section:load', (event) => {
        initIfNeeded(event?.target || document);
    });

    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (!(node instanceof HTMLElement)) continue;
                if (node.matches?.(SELECTOR) || node.querySelector?.(SELECTOR)) {
                    initIfNeeded(node);
                    return;
                }
            }
        }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
})();
